/*
 * @Author: qinqianwen
 * @Date: 2020-08-22 15:36:50
 * @LastEditTime: 2020-09-05 11:27:38
 * @LastEditors: Please set LastEditors
 * @Description: 进度提醒设置页面api
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\api\progressRemindSetting.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_BASE_WEB,
  E6_MS_TMS_E6YUN_BASE_WEB
} = e6ModuleOrderWaybillProcessApi;

//获取 订单运输进度提醒 相关信息
export function fetchOrderTransportInfo() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/processRemindReceiverSet/queryInfo`,
    method: "get"
  });
}
//保存 订单运输进度提醒 相关信息
export function saveOrderTransportInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/processRemindBusinessSet/updateReceiverRemind`,
    method: "post",
    data
  });
}
//获取 订单、运单业务提醒 相关信息
export function fetchOrderBusinessInfo() {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/processRemindBusinessSet/queryInfo`,
    method: "get"
  });
}
//保存 订单业务提醒 相关信息
export function saveOrderBusinessInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/processRemindBusinessSet/updateOrderBizRemind`,
    method: "post",
    data
  });
}

//保存 运单业务提醒 相关信息
export function saveWaybillInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/processRemindBusinessSet/updateWaybillBizRemind`,
    method: "post",
    data
  });
}

//获取子用户下拉
export function getSubUserList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getSubUserList`,
    // url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getSubWebgisUserList`,
    method: "post",
    data
  });
}
